// extracted by mini-css-extract-plugin
export default {"inputs":"FeesDetails_inputs__YXJt3","inputs__section":"FeesDetails_inputs__section__P8ka-","inputSubtitle":"FeesDetails_inputSubtitle__SXuuX"};